import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ThemeButton from '../qed-theme-module/ThemeButton';
import { isStringValue } from '../utility-files/data-util/DataHandling';

function CommonMap({ showMap, handleClose, latitude, longitude, title }) {
    const themeData = useSelector((state) => state.reduxReducer.themeData);
    const [address, setAddress] = useState('');

    const elementStyle = {
        fontFamily: isStringValue(themeData?.fontName),
        color: isStringValue(themeData?.textColor)
    };

    const lat = Number(latitude);
    const lng = Number(longitude);
    const hasValidCoords = !isNaN(lat) && !isNaN(lng) && (lat !== 0 || lng !== 0);

    // Keyless Google Maps embed: drops a marker at the given coordinates.
    const mapSrc = `https://maps.google.com/maps?q=${lat},${lng}&z=15&output=embed`;

    useEffect(() => {
        if (!showMap || !hasValidCoords) {
            setAddress('');
            return;
        }
        let isActive = true;
        setAddress('Fetching address...');
        // Keyless reverse geocoding via OpenStreetMap Nominatim.
        fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`)
            .then((res) => res.json())
            .then((data) => {
                if (isActive) {
                    setAddress(isStringValue(data?.display_name) || `${lat}, ${lng}`);
                }
            })
            .catch(() => {
                if (isActive) {
                    setAddress(`${lat}, ${lng}`);
                }
            });
        return () => { isActive = false; };
    }, [showMap, lat, lng, hasValidCoords]);

    return (
        <div
            className={`modal ${showMap && hasValidCoords ? 'show pageoverlay-model' : 'fade'}`}
            id="CommonMap"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="CommonMap"
            aria-hidden={!showMap}
            data-bs-keyboard="false"
            data-bs-backdrop="static"
        >
            <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 style={elementStyle} className="modal-title">{title || 'Location'}</h5>
                        <ThemeButton type="button" className="btn btn-primary" onClick={() => handleClose()}>Close</ThemeButton>
                    </div>
                    <div className="modal-body">
                        {hasValidCoords && (
                            <>
                                {address && (
                                    <p style={elementStyle} className="mb-2 d-flex gap-2">
                                        <strong>Address:</strong>
                                        <span>{address}</span>
                                    </p>
                                )}
                                <iframe
                                    title="location-map"
                                    src={mapSrc}
                                    width="100%"
                                    height="450"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CommonMap;
